'use strict';

const {filter} = require('lodash/collection');
//const DateUtils = require('utils/DateUtils');
//const SessionStore = require('stores/SessionStore');
const renderedOrdersEl = {}; // using HashMap in memory to perform O(1) constant time


function addOrderEl(from, to, orderId, orderEl) {
    renderedOrdersEl[_getKey(from, to, orderId)] = orderEl;
}

function addBatchEl(from, to, orderId, orderEl) {
    renderedOrdersEl[_getKeyBrewing(from, to, orderId)] = orderEl;
}

function getOrderEl(from, to, orderId) {
    return renderedOrdersEl[_getKey(from, to, orderId)];
}

function getBatchEl(from, to, orderId) {
    return renderedOrdersEl[_getKeyBrewing(from, to, orderId)];
}

function removeOrder(orderId) {
    const keys = Object.keys(renderedOrdersEl);
    const targetKeys = filter(keys, key => key.indexOf(orderId) > -1) || [];

    targetKeys.forEach(key => {
        renderedOrdersEl[key] = undefined;
    });
}

function cleanCacheFromDate(/*fromDate*/) {
    /*
    Object.keys(renderedOrdersEl).forEach(key => {
        const orderFromDate = key.substring(0, key.indexOf('_'));
        if (DateUtils.isAfterOrEquals(orderFromDate, fromDate)) {
            renderedOrdersEl[key] = undefined;
        }
    });
    */
}

function removeOrderAndCleanCacheScopeInventory(/*orderId*/) {
    //removeOrder(orderId);
    //cleanCacheFromDate(SessionStore.getMaxScopeInventoryDate());
}

function _getKey(from, to, orderId) {
    return `${from}_${to}_${orderId}`;
}

function _getKeyBrewing(from, to, orderId) {
    return `${from}_${to}_${orderId}__BH`;
}

function cleanCache() {
    Object.keys(renderedOrdersEl, key => {
        renderedOrdersEl[key] = undefined;
    });
}

module.exports = {
    getOrderEl,
    getBatchEl,
    addOrderEl,
    addBatchEl,
    cleanCache,
    cleanCacheFromDate,
    removeOrder,
    removeOrderAndCleanCacheScopeInventory
};



/** WEBPACK FOOTER **
 ** ./src/views/Dashboard/DashboardCache.js
 **/